import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './ContentPullQuote.module.scss'

/** @type {import('./types').default} */
const ContentPullQuote = ({ quote, author, title }) => {
  return (
    <div className={clsx('ContentPullQuote', classes.root)}>
      <Icon icon={['fas', 'quote-left']} className={classes.icon} />
      <p className={classes.quote}>{quote}</p>
      <p className={classes.author}>
        &mdash;<span>{author}</span>,{' '}
        <span>
          <em>{title}</em>
        </span>
      </p>
      <Icon icon={['fas', 'quote-right']} className={classes.icon} />
    </div>
  )
}

export default ContentPullQuote
